// classic entry point for this page - fetches servicedesk data then renders ui
import React from 'react';
import Spinner from '@atlassian/jira-common-components-spinner/src/view.tsx';
import { GenericError } from '@atlassian/jira-servicedesk-spa-commons/src/common/utils/errors';
import { useClassicSettingsProvider } from '../../services/classic-settings-provider';
import CustomerPortalChannelsApp from '../../ui/index.tsx';

export type Props = {
	isProjectSimplified: boolean;
	isAdmin: boolean;
	baseUrl: string;
	projectId: number;
	projectKey: string;
	projectName: string;
	showPageHeader?: boolean;
};

export const CustomerPortalClassicEntry = (props: Props) => {
	const {
		baseUrl,
		isAdmin,
		projectId,
		projectKey,
		isProjectSimplified,
		projectName,
		showPageHeader = true,
	} = props;

	const { data, error } = useClassicSettingsProvider({ projectKey });

	if (error) {
		return <GenericError />;
	}

	if (!data) {
		return <Spinner />;
	}

	const {
		name,
		announcementSettings: {
			canAgentsManagePortalAnnouncement,
			canAgentsManageHelpCenterAnnouncement,
		},
		canAdministerJIRA,
		description,
		portalLogoUrl,
		serviceDeskOpenAccess,
		portalUrl,
		helpCenterUrl,
	} = data;

	return (
		<CustomerPortalChannelsApp
			baseUrl={baseUrl}
			projectId={projectId}
			isNextGen={isProjectSimplified}
			projectKey={projectKey}
			isOpenAccess={serviceDeskOpenAccess}
			isAdmin={isAdmin}
			projectName={projectName}
			name={name}
			description={description}
			portalLogoUrl={portalLogoUrl}
			canAdministerJira={canAdministerJIRA}
			canAgentsManagePortalAnnouncement={canAgentsManagePortalAnnouncement}
			canAgentsManageHelpCenterAnnouncement={canAgentsManageHelpCenterAnnouncement}
			// Used for jsd-request-types-redesign
			showPageHeader={showPageHeader}
			portalUrl={portalUrl}
			helpCenterUrl={helpCenterUrl}
		/>
	);
};

export default CustomerPortalClassicEntry;
